import React, {FunctionComponent} from "react";
import {ActionFieldProps} from "../../features/actions/common/commonTypes";
import {SubtleTextbox, harvestErrors} from "./SubtleTextBox";
import IconButton from "../buttons/IconButton";
import {faGithub} from "@fortawesome/free-brands-svg-icons";
import FlexContainer from "../FlexContainer";

const GithubInput: FunctionComponent<ActionFieldProps> = (
    {
        defaultValue,
        formState,
        resetField,
        validatingRegister,
        mutationResults
    }
) => {
    return <FlexContainer alignItems={'center'}>
        <IconButton
            icon={faGithub as any}
            tooltip=""
            size="xs"
            iconSize='lg'
            style={{marginLeft: '4px'}}
            onClick={() => {
            }}
            showTooltip={true}
        />
        <SubtleTextbox
            {...validatingRegister('github', {})}
            label="Github"
            defaultValue={defaultValue}
            isDirty={Boolean(formState.dirtyFields.github)}
            onReset={() => resetField('github')}
            error={harvestErrors(
                'github',
                formState,
                mutationResults
            )}
        />
    </FlexContainer>;
}

export default GithubInput;
